module.exports = __webpack_public_path__ + "static/media/rocket.3603562b.svg";